import genericAttributeModule from "./genericAttributeModule"
import server from "../server"

genericAttributeModule.service("genericAttributeService", ["$http", function ($http) {
    this.getAttributableTypes = () => {
        return $http.get(server.getServiceUrl("edition.generic-attribute") + "attributableTypes")
            .then((response) => response.data)
    }
}])